import { useState } from "react";
import useMerchantPortalAxios from "../utils/axios";

const StatementOfAccountAPI = () => {
  const MerchantPortalAxios = useMerchantPortalAxios();
  const [GetStatementData, SetStatementData] = useState([]);
  const [totalNbOfPage, SetTotalNbOfPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [soaLoading, setSoaLoading] = useState(true);
  const [exportLoading, setExportLoading] = useState(false);

  const [exportData, setExportData] = useState(null);

  async function GetSOAList(
    CurrencyID,
    pageNb,
    dateFrom,
    dateTo,
    transactionType, 
    accountType = 1
  ) {
    setSoaLoading(true);
    await MerchantPortalAxios.post(
      `/v1/StatementOfAccount/GetSOAList`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
        CurrencyID: CurrencyID,
        page: pageNb,
        pageSize: 10,
        DateFrom: dateFrom,
        DateTo: dateTo,
        TransactionType: transactionType,
        AccountType: accountType
      },
      { timeout: 60000 }
    ).then((res) => {
      SetStatementData(res.data.Payload.StatementsOfAccount);
      if (res.data.Payload.StatementsOfAccount?.length === 0) {
        SetTotalNbOfPage(0);
        setTotalCount(0);
      } else {
        SetTotalNbOfPage(res.data.Payload.StatementsOfAccount[0].TotalPages);
        setTotalCount(res.data.Payload.StatementsOfAccount[0].TotalCount);
      }
      setSoaLoading(false);
    });
  }

  const dateFormat = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const timeFormat = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString();
  };

  async function getSOExport(CurrencyID, dateFrom, dateTo, transactionType) {
    setExportLoading(true);
    await MerchantPortalAxios.post(`/v1/StatementOfAccount/GetSOAList`, {
      SessionID: sessionStorage.getItem("SessionID"),
      CurrencyID: CurrencyID,
      page: 1,
      pageSize: 1,
      DateFrom: dateFrom,
      DateTo: dateTo,
      TransactionType: transactionType,
      isExport: true,
    },  { timeout: 60000 })
      .then((res) => {
        const updatedData = res.data.Payload.StatementsOfAccount.map((item) => {
          const { Row, TotalPages, TotalCount, PaymentDate, ...rest } = item;
          const formattedPaymentDate = new Date(PaymentDate);

          if (!isNaN(formattedPaymentDate.getTime())) {
            rest.PaymentDate = dateFormat(formattedPaymentDate);
            rest.PaymentTime = timeFormat(formattedPaymentDate);
          }

          return rest;
        });

        setExportData(updatedData);
      })
      .finally(() => {
        setExportLoading(false);
      });
  }

  const DownloadCorporateSoa = async (payload) => {
    const res = await MerchantPortalAxios.post(
      `/v1/StatementOfAccount/DownloadCorporateSoa`,
      payload
    );
    return res.data.Payload;
  };

  return {
    GetSOAList,
    GetStatementData,
    totalNbOfPage,
    totalCount,
    soaLoading,
    getSOExport,
    exportData,
    setExportData,
    exportLoading,
    DownloadCorporateSoa,
  };
};

export default StatementOfAccountAPI;
